(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/utils/assets/javascripts/get-label-for-sport-event.js') >= 0) return;  svs.modules.push('/components/pool-betting/utils/assets/javascripts/get-label-for-sport-event.js');
"use strict";


const {
  SportEventStatus
} = svs.components.sport.sportEventCommon;
const getPeriodText = sportEventStatus => {
  if (sportEventStatus === SportEventStatus.FirstPeriod) {
    return ' period 1, i';
  } else if (sportEventStatus === SportEventStatus.SecondPeriod) {
    return ' period 2, i';
  } else if (sportEventStatus === SportEventStatus.ThirdPeriod) {
    return ' period 3, i';
  }
  return '';
};
const statusWithPeriodsAndHalftime = [SportEventStatus.FirstHalf, SportEventStatus.SecondHalf, SportEventStatus.FirstPeriod, SportEventStatus.SecondPeriod, SportEventStatus.ThirdPeriod];
const getLabelForSportEvent = _ref => {
  let {
    eventResult,
    matchStatus,
    sportEventStatus
  } = _ref;
  if (!matchStatus) {
    return '';
  }
  const {
    isOngoing,
    isFinished,
    matchStatusText,
    isCancelled
  } = matchStatus;
  const hasEventStarted = isOngoing || isFinished;
  const getMatchLabel = (matchStatusText, isOngoing, isFinished) => {
    if (sportEventStatus === SportEventStatus.Halftime) {
      return 'Match startad, halvtid spelad';
    } else if (sportEventStatus === SportEventStatus.Cancelled) {
      return 'Match inställd';
    } else if (sportEventStatus === SportEventStatus.Delayed) {
      return 'Match försenad';
    } else if (isOngoing && statusWithPeriodsAndHalftime.includes(sportEventStatus)) {
      return "Match p\xE5g\xE5r i".concat(getPeriodText(sportEventStatus), " minut ").concat(matchStatusText);
    } else if (isOngoing) {
      return 'Match pågår';
    } else if (isFinished) {
      return "Match avslutad";
    } else if (!isOngoing && !isFinished && !isCancelled && sportEventStatus === SportEventStatus.NotStarted) {
      return "Match startar ".concat(matchStatusText);
    }
  };
  const getResultText = (eventResult, isCancelled, eventHasStarted) => {
    if (!eventHasStarted) {
      return '';
    }
    let formattedResult = eventResult ? ", resultat ".concat(eventResult) : '';
    formattedResult = isCancelled ? '' : formattedResult;
    return formattedResult;
  };
  return "".concat(getMatchLabel(matchStatusText, isOngoing, isFinished)).concat(getResultText(eventResult, isCancelled, hasEventStarted));
};
setGlobal('svs.components.poolBetting.utils.getLabelForSportEvent', getLabelForSportEvent);

 })(window);